import React from 'react';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';

const ServiceList = () => {
  return (
    <div className="bg-lightBackground py-10">
      {/* Container to manage alignment and spacing */}
      <div className="  mx-5 px-4">
        {/* Responsive grid for individual items */}
        <div className="grid grid-cols-1 gap-5 md:grid-cols-3 lg:flex justify-around lg:w-full">
          <div className="flex items-center space-x-3">
            <IoMdCheckmarkCircleOutline className="text-green h-10 w-10" size={30} />
            <span className="text-2xl font-bold">Customized Care Plans</span>
          </div>
          <div className="flex items-center space-x-3">
            <IoMdCheckmarkCircleOutline className="text-green h-10 w-10"  />
            <span className="text-2xl font-bold">Effective Pain Relief</span>
          </div>
          <div className="flex items-center space-x-3">
            <IoMdCheckmarkCircleOutline className="text-green h-10 w-10" size={30} />
            <span className="text-2xl font-bold">Improved Movements</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceList;